import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  Input,
  EventEmitter,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ss-paypal-confirm-modal',
  templateUrl: './ss-paypal-confirm-modal.component.html',
  styleUrls: ['./ss-paypal-confirm-modal.component.scss']
})
export class SsPaypalConfirmModalComponent implements OnInit {
  @ViewChild('content', { static: true }) private contentElem: ElementRef;
  @Output() confirmed = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Output() authorized = new EventEmitter();
  @Output() loading = new EventEmitter();
  @Output() error = new EventEmitter();
  @Input() charge = null;
  title = '';
  description = '';
  cancelText = 'Cancel';
  confirmText = 'Ok';
  iconClass = 'fa fa-exclamation-triangle';
  modalRef;
  paying = false;

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
  }

  paypalAuthorized() {
    console.log('auth pay');
    this.modalRef.dismiss();
    this.authorized.emit();
  }

  handleLoading() {
    // this.modalRef.dismiss();
    this.paying = true;
    this.loading.emit();
  }

  handleError() {
    this.modalRef.dismiss();
    this.error.emit();
  }

  open(title, description, cancelText, confirmText, iconClass = null) {
    this.paying = false;
    this.title = title;
    this.description = description;
    if (cancelText) {
      this.cancelText = cancelText;
    }
    if (confirmText) {
      this.confirmText = confirmText;
    }
    if (iconClass) {
      this.iconClass = iconClass;
    }
    this.openModal();
  }

  openModal() {
    this.modalRef = this.modalService.open(this.contentElem, {
      windowClass: 'ss-warning-modal',
      backdrop: 'static',
    });

    this.modalRef.result.then(
      result => {
        if (this.closed) {
          this.closed.emit();
        }
      },
      async reason => {
        if (this.confirmed) {
          this.confirmed.emit();
        }
      }
    );
  }

}
